import React, { useEffect, useState } from "react"
import Sidebar from "../components/sidebar"
import { Link, useNavigate, useParams } from "react-router-dom"
import axios from "../axiosInstance"

import Topbar from "../components/topbar"
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Pagination from "../components/Pagination"
import { errorMessage, postUserLog } from "../hooks/UserLogs"
import ConfirmModal from "../components/confirmModal"
import { convertToDate, formatQueryDate, isDateRangeWithinOneMonth, isValidDateRange, shiftCalendarMonths } from "../utils/date"
import { appendQueryParam, hasAnyQueryValue } from "../utils/query"
import { downloadBlob, getTimestampedFilename } from "../utils/download"

const PAGE_LIMIT = 10
const MANUFACTURER_OPTIONS = ["MBH", "Conlog"]

const hasBillerSearchFilters = ({ code, phone, beginDate, billerReference, paymentMethodId, invoiceStatus, manufacturer }) => {
  return hasAnyQueryValue([code, phone, beginDate, billerReference, paymentMethodId, invoiceStatus, manufacturer])
}

const buildBillerInvoiceUrl = ({ page, beginDate, endDate, phone, code, billerReference, paymentMethodId, invoiceStatus, manufacturer }) => {
  let ulr = "/biller-invoice?page=" + page + "&limit=" + PAGE_LIMIT
  const shouldSearch = hasBillerSearchFilters({ code, phone, beginDate, billerReference, paymentMethodId, invoiceStatus, manufacturer })

  if (shouldSearch) {
    ulr = "/biller-invoice/searche?page=" + page + "&limit=" + PAGE_LIMIT
    if (beginDate !== '' && endDate !== '') {
      ulr = appendQueryParam(ulr, "beginDate", convertToDate(new Date(beginDate)))
    }
    if (endDate !== '') {
      ulr = appendQueryParam(ulr, "endDate", convertToDate(new Date(endDate)))
    }
    ulr = appendQueryParam(ulr, "code", code)
    ulr = appendQueryParam(ulr, "phone", phone)
    ulr = appendQueryParam(ulr, "billerReference", billerReference)
    ulr = appendQueryParam(ulr, "idPaymentMode", paymentMethodId)
    ulr = appendQueryParam(ulr, "invoiceStatus", invoiceStatus)
    ulr = appendQueryParam(ulr, "manufacturer", manufacturer)
  }

  return ulr
}

export default function Invoices () {
  const [view, setView] = useState(false)
  const [totalPage, setTotalPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [ListInvoices, setListInvoices] = useState([])
  const [paymentMethods, setPaymentMethods] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [email, setEmail] = useState("")
  const [phone, setPhone] = useState("")
  const [code, setCode] = useState("")
  const [billerReference, setBillerReference] = useState("")
  const [codeBillerInvoice, setCodeBillerInvoice] = useState("")
  const [phoneBillerInvoice, setPhoneBillerInvoice] = useState("")
  const [firstNameUp, setFirstNameUp] = useState("")
  const [lastNameUp, setLastNameUp] = useState("")
  const [middleNameUp, setMiddleNameUp] = useState("")
  const [phoneUp, setPhoneUp] = useState("")
  const [emailUp, setEmailUp] = useState("")
  const [phoneMarchand, setPhoneMarchand] = useState("")
  const [phoneCustomer, setPhoneCustomer] = useState("")
  const [genderUp, setGenderUp] = useState("")
  const [agenceCode, setagenceCode] = useState("")
  const [emailStaff, setEmailStaff] = useState("")
  const [errorForm, setErrorForm] = useState({})
  const [errMsg, setErrorMsg] = useState("Une erreure s'est produite!!")
  const [showError, setShowError] = useState(false)
  const [idUp, setIdUp] = useState(0)
  const [trxType, setTrxType] = useState(0)
  const [imgUrl, setImgUrl] = useState('')
  const [paymentMethodId, setpaymentMethodId] = useState('')
  const [showModalConfirmValidation, setShowModalConfirmValidation] = useState(false)
  const [idInvoiceStartupMaster, setIdInvoiceStartupMaster] = useState('')
  const [transactionStatus, setTransactionStatus] = useState('')
  const [invoiceStatus, setInvoiceStatus] = useState('')
  const [manufacturer, setManufacturer] = useState('')
  const [showUpdateStatusModal, setShowUpdateStatusModal] = useState(false)
  const [idBillerInvoiceUp, setIdBillerInvoiceUp] = useState('')
  // const [invoiceCode, setInvoiceCode] = useState('')
  const [tokenUp, setTokenUp] = useState('')
  const [energyCoastUp, setEnergyCoastUp] = useState('')
  const [updateStatusErrors, setUpdateStatusErrors] = useState({})
  const [showRefreshTokenResultModal, setShowRefreshTokenResultModal] = useState(false)
  const [reloadBillerResult, setReloadBillerResult] = useState('')
  const [numberOfKwResult, setNumberOfKwResult] = useState('')
  const [showBillerExportDateModal, setShowBillerExportDateModal] = useState(false)
  const [exportBeginDate, setExportBeginDate] = useState('')
  const [exportEndDate, setExportEndDate] = useState('')
  const [exportDateError, setExportDateError] = useState('')
  const [isExporting, setIsExporting] = useState(false)

  let defaultBgDate = new Date()
  defaultBgDate.setDate(defaultBgDate.getDate() - 3)
  let defaultEndDate = new Date()
  defaultEndDate.setDate(defaultEndDate.getDate() + 1)
  const [beginDate, setBeginDate] = useState(defaultBgDate)
  const [endDate, setEnDate] = useState(defaultEndDate)

  const handleShowConfirmValidation = (id) => {
    setShowModalConfirmValidation(true)
    setIdInvoiceStartupMaster(id)

  }

  const handleCloseConfirmValidation = () => setShowModalConfirmValidation(false)

  const handleOpenUpdateStatus = (invoice) => {
    setIdBillerInvoiceUp(invoice.idBillerInvoice)
    // setInvoiceCode(invoice.invoiceCode)
    setShowUpdateStatusModal(true)
  }

  const handleCloseUpdateStatus = () => {
    setShowUpdateStatusModal(false)
    setIdBillerInvoiceUp('')
    // setInvoiceCode('')
    setTokenUp('')
    setEnergyCoastUp('')
    setUpdateStatusErrors({})
  }

  const submitUpdateBillInvoiceStatus = async () => {
    let error = {}
    let isvalid = true
    if (tokenUp === '') {
      error.tokenUp = "Field is required!"
      isvalid = false
    }
    if (energyCoastUp === '' || isNaN(Number(energyCoastUp))) {
      error.energyCoastUp = "Field is required!"
      isvalid = false
    }
    setUpdateStatusErrors(error)
    if (!isvalid) {
      return
    }

    setIsLoading(true)
    let url = bUrl + "/biller-invoice/updateBillInvoiceStatus?idBillerInvoice=" + encodeURIComponent(idBillerInvoiceUp)
    url += "&token=" + encodeURIComponent(tokenUp)
    url += "&energyCoast=" + encodeURIComponent(energyCoastUp)

    const response = await axiosInstance.get(url).catch((err) => {
      setIsLoading(false)
      if (err?.response?.status == 401 || err?.response?.status == 403) {
        setErrorMsg("Vous n'étes pas autorisé à faire cette opération")
        setShowError(true)
      } else {
        setShowError(true)
      }
    })

    if (response) {
      setIsLoading(false)
      if (response?.data?.isError) {
        const msg = errorMessage(response.data.code)
        setErrorMsg(msg)
        setShowError(true)
      } else {
        handleCloseUpdateStatus()
        getListBiller(beginDate, endDate, phoneBillerInvoice, codeBillerInvoice, billerReference, paymentMethodId, invoiceStatus, manufacturer)
        // await postUserLog(bUrl + "/userLogs/addUserLogs", 'Update bill invoice status', invoiceCode)
      }
    }
  }

  const handleCloseRefreshTokenResult = () => {
    setShowRefreshTokenResultModal(false)
    setReloadBillerResult('')
    setNumberOfKwResult('')
  }

  const refreshBillerToken = async (invoice) => {
    if (invoice.invoiceStatus != 'W') return

    setIsLoading(true)
    const url = bUrl + "/biller-invoice/updateBillerInvoiceToPaidByIdRef?idRef=" + encodeURIComponent(invoice.idReference)

    const response = await axiosInstance.get(url).catch((err) => {
      setIsLoading(false)
      if (err?.response?.status == 401 || err?.response?.status == 403) {
        setErrorMsg("Vous n'étes pas autorisé à faire cette opération")
      } else {
        const failMsg = err?.response?.data?.msg
        setErrorMsg(failMsg || "Une erreure s'est produite!!")
      }
      setShowError(true)
    })

    if (response) {
      setIsLoading(false)
      if (response?.data?.isError) {
        const failMsg = response.data.msg || errorMessage(response.data.code)
        setErrorMsg(failMsg)
        setShowError(true)
      } else {
        const body = response.data.body || {}
        setReloadBillerResult(body.ReloadBiller ?? body.reloadBiller ?? '')
        setNumberOfKwResult(body.NumberOfKw ?? body.numberOfKw ?? '')
        setShowRefreshTokenResultModal(true)
        getListBiller(beginDate, endDate, phoneBillerInvoice, codeBillerInvoice, billerReference, paymentMethodId, invoiceStatus, manufacturer)
      }
    }
  }

  const axiosInstance = axios.create({
    withCredentials: true,
  })
  let header =
  {
    'Content-Type': 'application/json'
  }

  const handleClose = () => {
    setErrorForm({})
    setFirstNameUp("")
    setLastNameUp("")
    setMiddleNameUp("")
    setGenderUp("")
    setEmailUp("")
    setIdUp(0)
    setPhoneUp("")
    setView(false)

  }

  const viewClose = () => {
    setView(false)
  }

  const getImgUrl = async (key) => {
    const response = await axiosInstance.get(bUrl + "/getFileUploaded?key=" + key).catch((err) => {
      console.log(err)
      setIsLoading(false)
    })
    if (response) {
      if (response.status == 401) {
        navigate('/backoffice/login')
      }
      if (!response.data.isError) {
        setImgUrl(response.data.body)
      } else {
        const msg = errorMessage(response.data.code)
        setErrorMsg(msg)
        setShowError(true)
      }

    }
  }
  const viewOpen = (key) => {
    getImgUrl(key)
    setView(true)
  }
  const handleCloseError = () => {
    setShowError(false)
  }
  const addForm = () => {
    let error = {}
    let isvalid = true
    if (emailUp == "") {
      error.emailUp = "Field is required!"
      isvalid = false
    }
    if (firstNameUp == "") {
      error.firstNameUp = "Field is required!"
      isvalid = false
    }
    if (lastNameUp == "") {
      error.lastNameUp = "Field is required!"
      isvalid = false
    }
    if (genderUp == "") {
      error.genderUp = "Field is required!"
      isvalid = false
    }
    if (phoneUp == "") {
      error.phoneUp = "Field is required!"
      isvalid = false
    }

    setErrorForm(error)
    if (isvalid) {
      setIsLoading(true)
      axios.post(bUrl + "/agent",

        //birthDay: birthDay,
        {
          "lastName": lastNameUp,
          "firstName": firstNameUp,
          "middleName": middleNameUp,
          "email": emailUp,
          "phone": phoneUp,
          "sexe": genderUp,
          "fkIdStaff": sessionStorage.getItem("idUser")
        }


        , { header: header })
        .then(function (response) {
          //getDayOffDayEmmp(idEmp);
          setIsLoading(false)

          handleClose()
          if (response.data.isError) {
            const msg = errorMessage(response.data.code)
            setErrorMsg(msg)
            setShowError(true)
          } else {
            getListInvoices(email, phone, code)
          }

        })
        .catch(function (error) {
          setIsLoading(false)

          console.log(error)
          setShowError(true)
        })
    }
  }
  const updateForm = () => { }

  const bUrl = process.env.REACT_APP_B_URL

  const { id } = useParams()
  const navigate = useNavigate()

  const getPaymentMethods = async () => {
    let ulr = "/paymentMode/find-all?page=1&limit=20"

    const response = await axiosInstance.get(bUrl + ulr).catch((err) => {

      if (err?.response?.status == 401 || err?.response?.status == 403) {
        setErrorMsg("Vous n'étes pas autorisé à faire cette opération")
        setShowError(true)
      } else {
        let msg = errMsg + ' ' + err?.response?.status ? (err?.response?.status) : ''
        setErrorMsg(msg)
        setShowError(true)
      }

      setIsLoading(false)

    })
    if (response) {
      if (response.status == 401) {
        navigate('/backoffice/login')
      }

      setPaymentMethods(response.data.body)

    }
  }

  const getListInvoices = async (beginDate, endDate, emailStaff, agenceCode, code, transactionStatus) => {
    let ulr = "/invoice-startup-master/find-all?page=" + currentPage + "&limit=10"
    setCode(code)
    setEmailStaff(emailStaff)
    setagenceCode(agenceCode)
    setPhone(phone)
    setTransactionStatus(transactionStatus)
    setBeginDate(new Date(beginDate))
    setEnDate(new Date(endDate))

    if (code != '' | emailStaff != '' | beginDate != '' | agenceCode != '') {
      ulr = "/invoice-startup-master/search?page=" + currentPage + "&limit=10"
      if (emailStaff != '') {
        ulr += "&StaffEmail=" + emailStaff
      }
      if (beginDate != '') {
        ulr += "&beginDate=" + convertToDate(new Date(beginDate))
      }
      if (endDate != '') {
        ulr += "&endDate=" + convertToDate(new Date(endDate))
      }
      if (code != '') {
        ulr += "&code=" + code
      }
      if (agenceCode != '') {
        ulr += "&agenceCode=" + agenceCode
      }
      if (transactionStatus != '') {
        ulr += "&status=" + transactionStatus
      }


    }
    const response = await axiosInstance.get(bUrl + ulr).catch((err) => {

      if (err?.response?.status == 401 || err?.response?.status == 403) {
        setErrorMsg("Vous n'étes pas autorisé à faire cette opération")
        setShowError(true)
        if (response.status == 401) {
          navigate('/backoffice/login')
        }
      } else {
        setShowError(true)
      }

      setIsLoading(false)

    })

    if (response) {
      if (response?.data?.isError) {
        const msg = errorMessage(response.data.code)
        setErrorMsg(msg)
        setShowError(true)
      } else {
        setListInvoices(response.data.body)
        setTotalPage(response.data.totalPage)
        setCurrentPage(response.data.currentPage)
      }

      setIsLoading(false)
    }
  }
  const getListBiller = async (beginDate, endDate, phone, code, billerReference, paymentMethodId, invoiceStatus, manufacturer) => {

    setCodeBillerInvoice(code)
    setPhoneBillerInvoice(phone)
    setBeginDate(new Date(beginDate))
    setEnDate(new Date(endDate))
    setBillerReference(billerReference)
    setpaymentMethodId(paymentMethodId)
    setInvoiceStatus(invoiceStatus)
    setManufacturer(manufacturer)

    let ulr = buildBillerInvoiceUrl({
      page: currentPage,
      beginDate,
      endDate,
      phone,
      code,
      billerReference,
      paymentMethodId,
      invoiceStatus,
      manufacturer,
    })
    const response = await axiosInstance.get(bUrl + ulr).catch((err) => {

      setIsLoading(false)
      if (err?.response?.status == 401 || err?.response?.status == 403) {
        setErrorMsg("Vous n'étes pas autorisé à faire cette opération (" + err?.response?.status + ")")
        setShowError(true)
      } else {
        setShowError(true)
      }

    })

    if (response) {
      if (response?.data?.isError) {
        const msg = errorMessage(response.data.code)
        setErrorMsg(msg)
        setShowError(true)
      }
      else {
        setListInvoices(response.data.body)
        setTotalPage(response.data.totalPage)
        setCurrentPage(response.data.currentPage)
      }
      setIsLoading(false)
    }

  }

  const getListAgentWallet = async (beginDate, endDate, phoneMarchand, phoneCustomer, code) => {

    let ulr = "/invoice-wallet-agent/find-all?page=" + currentPage + "&limit=10"
    setCode(code)
    setPhoneMarchand(phoneMarchand)
    setPhoneCustomer(phoneCustomer)
    setBeginDate(new Date(beginDate))
    setEnDate(new Date(endDate))
    if (code != '' | phone != '' | beginDate != '') {
      ulr = "/invoice-wallet-agent/searche?page=" + currentPage + "&limit=10"
      if (beginDate != '' && endDate != '') {
        ulr += "&beginDate=" + convertToDate(new Date(beginDate))
      }
      if (endDate != '') {
        ulr += "&endDate=" + convertToDate(new Date(endDate))
      }
      if (code != '') {
        ulr += "&code=" + code
      }
      if (phoneMarchand != '') {
        ulr += "&phoneAgent=" + phoneMarchand
      }
      if (phoneCustomer != '') {
        ulr += "&phoneCustomer=" + phoneCustomer
      }

    }

    const response = await axiosInstance.get(bUrl + ulr).catch((err) => {
      if (err?.response?.status == 401 || err?.response?.status == 403) {
        setErrorMsg("Vous n'étes pas autorisé à faire cette opération")
        setShowError(true)
      } else {
        setShowError(true)
      }

      setIsLoading(false)

    })
    if (response) {

      if (response?.data?.isError) {
        const msg = errorMessage(response.data.code)
        setErrorMsg(msg)
        setShowError(true)
      } else {
        setListInvoices(response.data.body)
        setTotalPage(response.data.totalPage)
        setCurrentPage(response.data.currentPage)
      }

      setIsLoading(false)
    }
  }
  const getInit = async (trxType) => {
    setTrxType(trxType)


    if (trxType == 0) {
      //biller
      getPaymentMethods()
      getListBiller(beginDate, endDate, phoneBillerInvoice, codeBillerInvoice, billerReference, paymentMethodId, invoiceStatus, manufacturer)

    } else if (trxType == 1) {
      //agent to customer
      getListAgentWallet(beginDate, endDate, phoneMarchand, phoneCustomer, code)

    } else if (trxType == 2) {
      //staff to agent
      getListInvoices(beginDate, endDate, emailStaff, agenceCode, code, transactionStatus)

    }


  }
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric", hour: 'numeric', minute: 'numeric', second: 'numeric' }
    return new Date(dateString).toLocaleDateString(undefined, options)
  }

  const getDownloadConfig = (downloadBeginDate, downloadEndDate) => {
    const params = {
      beginDate: convertToDate(new Date(downloadBeginDate)),
      endDate: convertToDate(new Date(downloadEndDate)),
    }

    if (Number(trxType) === 0) {
      if (phoneBillerInvoice !== '') params.phone = phoneBillerInvoice
      if (codeBillerInvoice !== '') params.code = codeBillerInvoice
      if (billerReference !== '') params.billerReference = billerReference
      if (paymentMethodId !== '') params.idPaymentMode = paymentMethodId
      if (invoiceStatus !== '') params.invoiceStatus = invoiceStatus
      if (manufacturer !== '') params.manufacturer = manufacturer
      return { endpoint: '/biller-invoice/downloadBiller', params }
    }

    if (Number(trxType) === 1) {
      if (phoneMarchand !== '') params.phoneAgent = phoneMarchand
      if (phoneCustomer !== '') params.phoneCustomer = phoneCustomer
      if (code !== '') params.code = code
      return { endpoint: '/invoice-wallet-agent/download', params }
    }

    if (emailStaff !== '') params.StaffEmail = emailStaff
    if (agenceCode !== '') params.agenceCode = agenceCode
    if (code !== '') params.code = code
    if (transactionStatus !== '') params.status = transactionStatus
    return { endpoint: '/invoice-startup-master/download', params }
  }

  const downloadInvoices = async (downloadBeginDate, downloadEndDate, fromModal = false) => {
    if (isExporting) return

    if (!isValidDateRange(downloadBeginDate, downloadEndDate)) {
      const message = "La date de fin doit être postérieure ou égale à la date de début."
      if (fromModal) setExportDateError(message)
      else {
        setErrorMsg(message)
        setShowError(true)
      }
      return
    }
    if (!isDateRangeWithinOneMonth(downloadBeginDate, downloadEndDate)) {
      const message = "La période d'export ne peut pas dépasser un mois."
      if (fromModal) setExportDateError(message)
      else {
        setErrorMsg(message)
        setShowError(true)
      }
      return
    }
    if (fromModal && (new Date(downloadBeginDate) < new Date(beginDate) || new Date(downloadEndDate) > new Date(endDate))) {
      setExportDateError("La période d'export doit rester comprise dans la période recherchée.")
      return
    }

    setExportDateError('')
    setIsExporting(true)
    try {
      const { endpoint, params } = getDownloadConfig(downloadBeginDate, downloadEndDate)
      const response = await axiosInstance.get(bUrl + endpoint, {
        params,
        responseType: 'blob',
      })
      const filename = Number(trxType) === 0
        ? 'invoice-biller'
        : Number(trxType) === 1
          ? 'invoice-wallet-agent'
          : 'invoice-startup-master'
      downloadBlob(response.data, getTimestampedFilename(filename))
      setShowBillerExportDateModal(false)
    } catch (err) {
      if (err?.response?.status === 401) {
        navigate('/backoffice/login')
      } else {
        const message = err?.response?.status === 403
          ? "Vous n'êtes pas autorisé à faire cette opération."
          : "Le téléchargement a échoué."
        if (fromModal) {
          setExportDateError(message)
        } else {
          setErrorMsg(message)
          setShowError(true)
        }
      }
    } finally {
      setIsExporting(false)
    }
  }

  const handleExport = () => {
    if (!isValidDateRange(beginDate, endDate)) {
      setErrorMsg("La date de fin doit être postérieure ou égale à la date de début.")
      setShowError(true)
      return
    }
    if (isDateRangeWithinOneMonth(beginDate, endDate)) {
      downloadInvoices(beginDate, endDate)
      return
    }

    const exportBegin = formatQueryDate(beginDate)
    setExportBeginDate(exportBegin)
    setExportEndDate(formatQueryDate(shiftCalendarMonths(beginDate, 1)))
    setExportDateError('')
    setShowBillerExportDateModal(true)
  }
  const validateAgentStaffTransactions = () => {

    setIsLoading(true)

    axiosInstance.post(bUrl + "/invoice-startup-master/validate-invoice-startup-master-of-agency-by-staff",

      //birthDay: birthDay,
      {
        "fkIdStaff": sessionStorage.getItem('idUser'),
        "idInvoiceStartupMaster": idInvoiceStartupMaster

      }

      , { header: header })
      .then(async (response) => {

        //setListInvoices(response.data.body);
        setIsLoading(false)

        if (response?.data?.isError) {
          const msg = errorMessage(response?.data?.code)
          setErrorMsg(msg)
          setShowError(true)
        } else {
          getListInvoices(beginDate, endDate, emailStaff, agenceCode, code, transactionStatus, transactionStatus)
          await postUserLog(bUrl + "/userLogs/addUserLogs", 'Validation ', response.data.body.invoiceCode,)
        }

      })
      .catch(function (err) {
        setIsLoading(false)
        console.error(err)

        if (err?.response?.status == 401 || err?.response?.status == 403) {
          setErrorMsg("Vous n'étes pas autorisé à faire cette opération")
          setShowError(true)
        } else {
          setShowError(true)
        }
        //setShowError(true);
      })

    handleCloseConfirmValidation()

  }
  useEffect(() => {
    if (sessionStorage.getItem("idUser") === '' || sessionStorage.getItem("name") === null) {
      //console.log("----------GO GO GO ------------")
      navigate('/backoffice/login')
    }

    getInit(trxType)
  }, [currentPage])

  return (
    <div className="App list-page">
      <div className="">
        <Sidebar />
        <section className="home ">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12 d-grid gap-3">
              <div className="table-content mt-2 p-2 text d-flex justify-content-between">
                <div>Transactions &gt; {trxType == 0 ? 'Facture' : trxType == 1 ? 'Dépot' : 'Marchant'}</div>
                <div><Topbar /></div>
              </div>
              <div className="d-grid pb-2 gap-3">
                <div className="list-filter-card">
                  <div className="list-filter-toolbar">
                    <div className="list-filter-fields">
                    <div className="list-field text">
                      <label htmlFor="exampleInputEmail1">Type</label>
                      <select onChange={(e) => getInit(e.target.value)} className="form-control" value={trxType}>
                        <option value={0}>Facture</option>
                        <option value={1}>Marchand à Client</option>
                        <option value={2}>Staff Agence Marchand</option>
                      </select>
                    </div>
                    {trxType == 0 ?
                      <>
                        <div className="list-field text">
                          <label htmlFor="exampleInputEmail1">Début</label>
                          <input type="Date" value={beginDate.toLocaleDateString('en-CA')} onChange={(e) => getListBiller(e.target.value, endDate, phoneBillerInvoice, codeBillerInvoice, billerReference, paymentMethodId, invoiceStatus, manufacturer)} className="form-control" id="exampleInputEmail1" />
                        </div>
                        <div className="list-field text">
                          <label htmlFor="phone">Fin</label>
                          <input type="Date" value={endDate.toLocaleDateString('en-CA')} onChange={(e) => getListBiller(beginDate, e.target.value, phoneBillerInvoice, codeBillerInvoice, billerReference, paymentMethodId, invoiceStatus, manufacturer)} className="form-control" id="phone" aria-describedby="Phone" placeholder="Phone" />
                        </div>

                        <div className="list-field text">
                          <label htmlFor="phone">Phone</label>
                          <input type="text" onChange={(e) => getListBiller(beginDate, endDate, e.target.value, codeBillerInvoice, billerReference, paymentMethodId, invoiceStatus, manufacturer)} className="form-control" id="phone" aria-describedby="Phone" placeholder="Phone" />
                        </div>


                        <div className="list-field text">
                          <label htmlFor="code">Code</label>
                          <input type="text" onChange={(e) => getListBiller(beginDate, endDate, phoneBillerInvoice, e.target.value, billerReference, paymentMethodId, invoiceStatus, manufacturer)} className="form-control" id="code" aria-describedby="Phone" placeholder="Code" />
                        </div>

                        <div className="list-field text">
                          <label htmlFor="code">Nº compteur</label>
                          <input type="text" onChange={(e) => getListBiller(beginDate, endDate, phoneBillerInvoice, codeBillerInvoice, e.target.value, paymentMethodId, invoiceStatus, manufacturer)} value={billerReference} className="form-control" id="code" aria-describedby="Phone" placeholder="Code" />
                        </div>

                        <div className="list-field text">
                          <label htmlFor="code">Type de payment</label>
                          <select onChange={(e) => getListBiller(beginDate, endDate, phoneBillerInvoice, codeBillerInvoice, billerReference, e.target.value, invoiceStatus, manufacturer)} className="form-control" value={paymentMethodId}>
                            <option value="">Sélectionner</option>
                            {paymentMethods == null ? <option value=""></option> : paymentMethods.length > 0 ? paymentMethods.map((a, i) => {
                              return ['AM', 'SM', 'DP'].includes(a.name) ? "" : <option key={i} value={a.idPaymentMode}>{a.description}</option>

                            }) : ""}

                          </select>
                        </div>
                        <div className="list-field text">
                          <label htmlFor="invoiceStatus">Status</label>
                          <select id="invoiceStatus" onChange={(e) => getListBiller(beginDate, endDate, phoneBillerInvoice, codeBillerInvoice, billerReference, paymentMethodId, e.target.value, manufacturer)} className="form-control" value={invoiceStatus}>
                            <option value="">Sélectionner</option>
                            <option value="P">Payée</option>
                            <option value="W">En attente</option>
                            <option value="F">Echec</option>
                          </select>
                        </div>
                        <div className="list-field text">
                          <label htmlFor="manufacturer">Manufacturer</label>
                          <select id="manufacturer" onChange={(e) => getListBiller(beginDate, endDate, phoneBillerInvoice, codeBillerInvoice, billerReference, paymentMethodId, invoiceStatus, e.target.value)} className="form-control" value={manufacturer}>
                            <option value="">Sélectionner</option>
                            {MANUFACTURER_OPTIONS.map((option) => (
                              <option key={option} value={option}>{option}</option>
                            ))}
                          </select>
                        </div>
                      </>
                      : <></>}

                    {trxType == 1 ?
                      <>
                        <div className="list-field text">
                          <label htmlFor="exampleInputEmail1">Début</label>
                          <input type="Date" value={beginDate.toLocaleDateString('en-CA')} onChange={(e) => getListAgentWallet(e.target.value, endDate, phoneMarchand, phoneCustomer, code)} className="form-control" id="exampleInputEmail1" />
                        </div>
                        <div className="list-field text">
                          <label htmlFor="phone">Fin</label>
                          <input type="Date" value={endDate.toLocaleDateString('en-CA')} onChange={(e) => getListAgentWallet(beginDate, e.target.value, phoneMarchand, phoneCustomer, code)} className="form-control" id="phone" aria-describedby="Phone" placeholder="Phone" />
                        </div>

                        <div className="list-field text">
                          <label htmlFor="phone">Marchand</label>
                          <input type="text" onChange={(e) => getListAgentWallet(beginDate, endDate, e.target.value, phoneCustomer, code)} className="form-control" id="phone" aria-describedby="Phone" placeholder="Phone" />
                        </div>

                        <div className="list-field text">
                          <label htmlFor="phone">Client</label>
                          <input type="text" onChange={(e) => getListAgentWallet(beginDate, endDate, phoneMarchand, e.target.value, code)} className="form-control" id="phone" aria-describedby="Phone" placeholder="Phone" />
                        </div>


                        <div className="list-field text">
                          <label htmlFor="code">Code</label>
                          <input type="text" onChange={(e) => getListAgentWallet(beginDate, endDate, phoneMarchand, phoneCustomer, e.target.value)} className="form-control" id="code" aria-describedby="Phone" placeholder="Code" />
                        </div>
                      </>
                      : <></>}

                    {trxType == 2 ?
                      <>
                        <div className="list-field text">
                          <label htmlFor="exampleInputEmail1">Début</label>
                          <input type="Date" value={beginDate.toLocaleDateString('en-CA')} onChange={(e) => getListInvoices(e.target.value, endDate, emailStaff, agenceCode, code, transactionStatus)} className="form-control" id="exampleInputEmail1" />
                        </div>
                        <div className="list-field text">
                          <label htmlFor="phone">Fin</label>
                          <input type="Date" value={endDate.toLocaleDateString('en-CA')} onChange={(e) => getListInvoices(beginDate, e.target.value, emailStaff, agenceCode, code, transactionStatus)} className="form-control" id="phone" aria-describedby="Phone" placeholder="Email" />
                        </div>

                        <div className="list-field text">
                          <label htmlFor="status">Status</label>
                          <select id="status" onChange={(e) => getListInvoices(beginDate, endDate, emailStaff, agenceCode, code, e.target.value)} className="form-control" value={transactionStatus}>
                            <option value="">Sélectionner</option>
                            <option value="A">Attente</option>
                            <option value="P">Payée</option>
                          </select>
                        </div>

                        <div className="list-field text">
                          <label htmlFor="email">Satff</label>
                          <input type="email" onChange={(e) => getListInvoices(beginDate, endDate, e.target.value, agenceCode, code, transactionStatus)} className="form-control" id="email" aria-describedby="Staff email" placeholder="email" />
                        </div>

                        <div className="list-field text">
                          <label htmlFor="agCode">Agence</label>
                          <input type="text" onChange={(e) => getListInvoices(beginDate, endDate, emailStaff, e.target.value, code, transactionStatus)} className="form-control" id="agCode" aria-describedby="Agence code" placeholder="Code" />
                        </div>

                        <div className="list-field text">
                          <label htmlFor="code">Code</label>
                          <input type="text" onChange={(e) => getListInvoices(beginDate, endDate, emailStaff, agenceCode, e.target.value, transactionStatus)} className="form-control" id="code" aria-describedby="Phone" placeholder="Code" />
                        </div>
                      </>
                      : <></>}
                    </div>
                    <div className="list-actions-group">
                      <button type="button" className="list-btn-primary" onClick={handleExport} disabled={isExporting} aria-busy={isExporting}>
                        {isExporting ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" /> : <i className="bx bx-download" />}
                        {isExporting ? 'Exportation...' : 'Exporter'}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="list-table-wrap p-3">
                  {/* <button onClick={() => viewOpen()}>
                  <i className='bx bxs-plus-circle icon'></i>
                </button> */}
                  {/* <a href="/Home/Create" className="btn btn-primary mb-1"> </a> */}
                  <div className="invoices-table-scroll">
                    {isLoading ? <div className='loading'><img src='../Custom.svg' /></div> :
                      trxType == 0 ?
                        <table className="table list-table text mb-0">
                          <thead>
                            <tr>
                              <th scope="col">Nº</th>
                              <th scope="col">Code</th>
                              <th scope="col">Nº compteur</th>
                              <th scope="col">Manufacturer</th>
                              <th scope="col">Code recharge</th>
                              <th scope="col">Client</th>
                              <th scope="col">Montant</th>
                              <th scope="col">Status</th>
                              <th scope="col">Date</th>
                              <th></th>
                              <th></th>
                            </tr>
                          </thead>

                          <tbody>
                            {ListInvoices == null ? <td></td> : ListInvoices.length > 0 ? ListInvoices.map((a, i) => {
                              return <tr key={i}>
                                <td>{i}</td>
                                <td>{a.invoiceCode}</td>
                                <td>{a.billerReference}</td>
                                <td>{a.manufacturer}</td>
                                <td>{a.reloadBiller}</td>
                                <td>{a.customerWallet ? a.customerWallet.phone : ""}</td>

                                <td>{a.amountToPaid}</td>
                                <td style={{ background: a.invoiceStatus == 'P' ? "rgb(0,255,0,.3)" : (a.invoiceStatus == 'W' ? "rgb(100,200,10,.1)" : "rgb(255,0,0,.3)") }}>{a.invoiceStatus == 'P' ? 'Payée' : (a.invoiceStatus == 'W' ? "En attente" : "Echec")}</td>


                                <td>{formatDate(a.createdDate)}</td>

                                <td>
                                  <Link to={"/biller/" + a.idBillerInvoice}><i className='bx bx-notepad' title="Détails"></i></Link>
                                  {' '}
                                  {a.invoiceStatus == 'W' ? (
                                    <Link onClick={() => handleOpenUpdateStatus(a)}><i className='bx bx-edit-alt' title="Modifier status"></i></Link>
                                  ) : (
                                    <span style={{ opacity: 0.35, cursor: 'not-allowed' }}><i className='bx bx-edit-alt' title="Disponible uniquement en attente"></i></span>
                                  )}
                                  {' '}
                                  {a.invoiceStatus == 'W' ? (
                                    <Link onClick={() => refreshBillerToken(a)}><i className='bx bx-refresh' title="Rafraîchir Token"></i></Link>
                                  ) : (
                                    <span style={{ opacity: 0.35, cursor: 'not-allowed' }}><i className='bx bx-refresh' title="Disponible uniquement en attente"></i></span>
                                  )}
                                </td>


                              </tr>
                            }) : <tr></tr>}
                          </tbody>

                        </table> :
                        trxType == 1 ?
                          <table className="table list-table text mb-0">
                            <thead>
                              <tr>

                                <th scope="col">N</th>
                                <th scope="col">Code</th>
                                <th scope="col">Marchand</th>
                                <th scope="col">client</th>
                                <th scope="col">Status</th>
                                <th scope="col">Montant</th>
                                <th scope="col">Date</th>
                                <th></th>
                                <th></th>
                              </tr>
                            </thead>

                            <tbody>
                              {ListInvoices == null ? <td></td> : ListInvoices.length > 0 ? ListInvoices.map((a, i) => {
                                return <tr key={i}>
                                  <td>{i}</td>
                                  <td>{a.invoiceCode}</td>
                                  <td>{a.agent ? a.agent.phone : ""}</td>
                                  <td>{a.customerWallet ? a.customerWallet.phone : ""}</td>
                                  <td style={{ background: a.invoiceStatus == 'P' ? "rgb(0,255,0,.3)" : "rgb(255,0,0,.3)" }}>{a.invoiceStatus == 'P' ? 'Payée' : 'Annulée'}</td>

                                  <td>{a.amountToPaid}</td>

                                  <td>{formatDate(a.createdDate)}</td>

                                  <td><Link to={"/invoiceagent/" + a.idInvoiceWalletCashier}><i className='bx bx-notepad' title="Détails"></i></Link></td>


                                </tr>
                              }) : <tr></tr>}
                            </tbody>

                          </table> :
                          trxType == 2 ?
                            <table className="table list-table text mb-0">
                              <thead>
                                <tr>

                                  <th scope="col">N</th>
                                  <th scope="col">Code</th>
                                  <th scope="col">Agent</th>
                                  <th scope="col">Staff</th>
                                  <th scope="col">Agence</th>
                                  <th scope="col">Status</th>
                                  <th scope="col">Montant</th>
                                  <th scope="col">Date</th>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                                </tr>
                              </thead>

                              <tbody>
                                {ListInvoices == null ? <td></td> : ListInvoices.length > 0 ? ListInvoices.map((a, i) => {
                                  return <tr key={i}>
                                    <td>{i}</td>
                                    <td>{a.invoiceCode}</td>
                                    <td>{a.agent ? a.agent.phone : ""}</td>
                                    <td>{a.staff ? a.staff.codeOwnerAgent : ""}</td>
                                    <td>{a.agencyUser != null ? a.agencyUser.agency != null ? a.agencyUser.agency.code : "" : ""}</td>
                                    <td style={{ background: a.invoiceStatus == 'P' ? "rgb(0,255,0,.3)" : a.invoiceStatus == 'A' ? "rgb(0,200,255,.3)" : "rgb(255,0,0,.3)" }}>{a.invoiceStatus == 'P' ? 'Payée' : a.invoiceStatus == 'A' ? 'En Attente' : 'Annulée'}</td>
                                    <td>{a.amountToPaid}</td>
                                    <td>{formatDate(a.createdDate)}</td>
                                    {
                                      a.invoiceStatus == 'A' ? (a.agent == null ?
                                        <td><Link onClick={() => handleShowConfirmValidation(a.idInvoiceStartupMaster)}><i className='bx bx-caret-up-square' title="Validé"></i></Link></td>
                                        : <> </>) : <> </>
                                    }
                                    <td><Link to={"/invoiceStartupMaster/" + a.idInvoiceStartupMaster}> <i className='bx bx-notepad' title="Détails"></i></Link></td>
                                    <td><Link onClick={() => viewOpen(a.proofLink)}><i className='bx bx-shield-alt-2' title=""></i></Link></td>


                                  </tr>
                                }) : <tr></tr>}
                              </tbody>

                            </table> : ""
                    }
                  </div>
                  <Pagination totalPage={totalPage} setCurrentPage={setCurrentPage} currentPage={currentPage} />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Modal show={view} onHide={handleClose} className="">
        <Modal.Header closeButton>
          <Modal.Title className="text-center"></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {(imgUrl != '') ? <img src={imgUrl} className="w-100" alt="image" /> : <p>Pas de preuve disponible</p>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Fermer
          </Button>

        </Modal.Footer>
      </Modal>

      <Modal
        show={showBillerExportDateModal}
        onHide={() => { if (!isExporting) setShowBillerExportDateModal(false) }}
        backdrop={isExporting ? 'static' : true}
        keyboard={!isExporting}
      >
        <Modal.Header closeButton={!isExporting}>
          <Modal.Title>Exporter les transactions</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>La période recherchée dépasse un mois. Sélectionnez une période d'export d'un mois maximum.</p>
          <div className="row g-3">
            <div className="col-md-6">
              <label htmlFor="exportBeginDate" className="form-label">Début</label>
              <input
                id="exportBeginDate"
                type="date"
                className="form-control"
                value={exportBeginDate}
                min={formatQueryDate(beginDate)}
                max={formatQueryDate(endDate)}
                disabled={isExporting}
                onChange={(e) => {
                  setExportBeginDate(e.target.value)
                  setExportDateError('')
                }}
              />
            </div>
            <div className="col-md-6">
              <label htmlFor="exportEndDate" className="form-label">Fin</label>
              <input
                id="exportEndDate"
                type="date"
                className="form-control"
                value={exportEndDate}
                min={exportBeginDate || formatQueryDate(beginDate)}
                max={formatQueryDate(endDate)}
                disabled={isExporting}
                onChange={(e) => {
                  setExportEndDate(e.target.value)
                  setExportDateError('')
                }}
              />
            </div>
          </div>
          {exportDateError ? <div className="text-danger mt-3">{exportDateError}</div> : null}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowBillerExportDateModal(false)} disabled={isExporting}>
            Fermer
          </Button>
          <Button variant="primary" onClick={() => downloadInvoices(exportBeginDate, exportEndDate, true)} disabled={isExporting}>
            {isExporting ? <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />Exportation...</> : 'Exporter'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* =============================================error=============================== */}
      <Modal show={showError} onHide={handleCloseError} className="">
        <Modal.Header closeButton className="bg-danger">
          <Modal.Title>ERREURE</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className='text-danger' style={{ textAlign: 'center' }}>{errMsg}</h5>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseError}>
            Fermer
          </Button>
        </Modal.Footer>
      </Modal>

      <ConfirmModal
        show={showModalConfirmValidation}
        handleClose={handleCloseConfirmValidation}
        handleConfirm={validateAgentStaffTransactions}
      />

      <Modal show={showUpdateStatusModal} onHide={handleCloseUpdateStatus}>
        <Modal.Header closeButton>
          <Modal.Title>Modifier le status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label htmlFor="tokenUp">Token</label>
            <input type="text" id="tokenUp" value={tokenUp} onChange={(e) => setTokenUp(e.target.value)} className="form-control" />
            {updateStatusErrors.tokenUp ? <span className="text-danger">{updateStatusErrors.tokenUp}</span> : ""}
          </div>
          <div className="mb-3">
            <label htmlFor="energyCoastUp">Énergie achetée(kWh)</label>
            <input type="number" id="energyCoastUp" value={energyCoastUp} onChange={(e) => setEnergyCoastUp(e.target.value)} className="form-control" />
            {updateStatusErrors.energyCoastUp ? <span className="text-danger">{updateStatusErrors.energyCoastUp}</span> : ""}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseUpdateStatus}>
            Fermer
          </Button>
          <Button variant="primary" onClick={submitUpdateBillInvoiceStatus}>
            Valider
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showRefreshTokenResultModal} onHide={handleCloseRefreshTokenResult}>
        <Modal.Header closeButton>
          <Modal.Title>Token rafraîchi</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-2">
            <strong>Token :</strong> {reloadBillerResult}
          </div>
          <div>
            <strong>Énergie achetée(kWh) :</strong> {numberOfKwResult}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseRefreshTokenResult}>
            Fermer
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
